<template>
  <div class="boxlist">
    <!-- 筛选 -->
    <!-- <h3 class="flex-row-start" style="margin-top: 0">条件筛选</h3> -->
    <el-form
      @submit.native.prevent
      ref="box-filter-form"
      :model="filter"
      label-width="100px"
      label-position="left"
    >
      <el-row>
        <el-col :span="8" v-if="user_is_pta">
          <el-form-item label="所属厂商:">
            <el-select
              v-model="filter.unit_id"
              placeholder="所属厂商"
              size="mini"
              @change="
                currentPage = 1;
                getBoxlist();
              "
              filterable
            >
              <el-option label="全部" value="all"></el-option>
              <el-option
                v-for="(value, key) in unitlist"
                :key="key"
                :label="value"
                :value="Number(key)"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-form-item label="盒子版本:">
            <el-select
              v-model="filter.version_code"
              placeholder="盒子版本"
              size="mini"
              @change="
                currentPage = 1;
                getBoxlist();
              "
              filterable
            >
              <el-option label="全部" value="all"></el-option>
              <el-option
                v-for="(value, key) in applist2"
                :key="key"
                :label="value"
                :value="Number(key)"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="7" :offset="1">
          <el-form-item label="目标版本:">
            <el-select
              v-model="filter.binded_app_id"
              placeholder="盒子版本"
              size="mini"
              @change="
                currentPage = 1;
                getBoxlist();
              "
              filterable
            >
              <el-option label="全部" value="all"></el-option>
              <el-option label="最高版本" :value="0"></el-option>
              <el-option
                v-for="(value, key) in applist"
                :key="key"
                :label="value"
                :value="Number(key)"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="是否显示wifi:">
            <el-radio-group
              v-model="filter.is_wifi_show"
              size="mini"
              @change="
                currentPage = 1;
                getBoxlist();
              "
            >
              <el-radio-button label="all">全部</el-radio-button>
              <el-radio-button :label="1">是</el-radio-button>
              <el-radio-button :label="0">否</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="10" :offset="2">
          <el-form-item label="关键字检索:">
            <el-input
              v-model="filter.cdit"
              placeholder="序列号、名称或硬件识别码"
              size="mini"
              style="min-width: 220px"
              @keyup.enter.native="
                currentPage = 1;
                getBoxlist();
              "
              clearable
              @clear="
                currentPage = 1;
                getBoxlist();
              "
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="
                  currentPage = 1;
                  getBoxlist();
                "
              >
              </el-button>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <!-- 盒子列表 -->
    <div class="flex-row-between">
      <div class="flex-row-start">
        <h3 width="100px">盒子列表</h3>
        <el-button
          style="margin-left: 16px"
          size="mini"
          v-if="user_is_pta"
          type="warning"
          @click="restartBox('all')"
          >重启所有盒子</el-button
        >
        <div style="margin-left: 30px">
          当前在线盒子数：{{ boxListCount }} 台
        </div>
      </div>

      <div>
        当前 {{ total > 0 ? pageStart + 1 : 0 }} -
        {{ pageEnd > total ? total : pageEnd }} 项, 共 {{ total }} 项
      </div>
    </div>

    <el-table
      :data="boxlist"
      style="width: 100%"
      border
      header-cell-class-name="myth"
      cell-class-name="mytd"
      v-loading="loading"
      :expand-row-keys="expandKey"
      :row-key="(row) => row.id"
      size="small"
      @expand-change="onExpandChange"
    >
      <el-table-column type="index" width="80" :index="indexMethod" />
      <el-table-column prop="sn" label="盒子序列号" />
      <el-table-column prop="show_title" label="盒子名称" />
      <el-table-column prop="huid" label="硬件识别码" />
      <el-table-column label="所属厂商">
        <template slot-scope="scope">
          {{ unitlist[scope.row["unit_id"]] || "未知" }}
        </template>
      </el-table-column>
      <el-table-column label="场馆/区域编码" v-if="user_is_pta">
        <template slot-scope="scope">
          {{ scope.row["venue_uuid"] }} / {{ scope.row["venue_area_uuid"] }}
        </template>
      </el-table-column>
      <el-table-column label="是否显示wifi">
        <template slot-scope="scope">
          {{ scope.row["is_wifi_show"] ? "是" : "否" }}
        </template>
      </el-table-column>
      <el-table-column label="信号显示强度">
        <template slot-scope="scope">
          {{ scope.row["rssi_limit"] }}
        </template>
      </el-table-column>
      <el-table-column label="盒子版本">
        <template slot-scope="scope">
          {{ scope.row["device_info"] && scope.row["device_info"].versionname }}
        </template>
      </el-table-column>
      <el-table-column label="目标版本">
        <template slot-scope="scope">
          {{
            scope.row["binded_app_id"] == 0
              ? `最高版本 (${scope.row.version_name})`
              : scope.row.version_name
          }}
        </template>
      </el-table-column>
      <el-table-column prop="last_dt" label="最后在线时间" width="180" />
      <el-table-column prop="last_mq_dt" label="最后MQ时间" width="180" />
      <el-table-column label="操作" type="expand">
        <template slot-scope="props">
          <div class="flex-row-around">
            <el-button
              type="primary"
              size="small"
              @click="handleSet(props.row)"
              v-if="user_is_admin || user_is_pta"
              >修改盒子
            </el-button>
            <el-button
              type="primary"
              plain
              size="small"
              @click="
                boxToSet = props.row;
                areaVisible = true;
              "
              v-if="user_is_pta"
              >老第三方主副盒子</el-button
            >
            <el-button
              @click="handleRemove(props.row)"
              type="danger"
              size="small"
              v-if="user_is_pta"
              >删除盒子
            </el-button>
            <el-button
              @click="restartBox(props.row)"
              type="warning"
              size="small"
              v-if="user_is_pta"
              >重启盒子
            </el-button>
            <el-button
              @click="clearStaticFile(props.row)"
              type="info"
              size="small"
              v-if="user_is_pta"
              >删除静态文件
            </el-button>
            <el-button
              @click="mqBox(props.row)"
              type="info"
              size="small"
              v-if="user_is_pta"
              >MQ</el-button
            >
            <el-button @click="showLog(props.row)" size="small">盒子日志</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <div class="flex-row-end" style="margin-top: 16px">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        v-if="total > pageSize"
        @current-change="onPageChange"
        :current-page.sync="currentPage"
      >
      </el-pagination>
    </div>

    <!-- 模态窗 -->
    <el-dialog
      :title="modalType == 'add' ? '新增盒子' : '修改盒子'"
      :visible.sync="modalVisible"
      width="600px"
      :before-close="handleClose"
    >
      <el-form
        @submit.native.prevent
        ref="box-form"
        :model="form"
        label-width="150px"
        :rules="rules"
      >
        <el-form-item label="盒子序列号">
          <el-input
            v-model="form.sn"
            placeholder="盒子序列号"
            style="width: 360px"
            disabled
          />
        </el-form-item>
        <el-form-item label="所属厂商" prop="unit_id">
          <el-select
            v-model="form.unit_id"
            placeholder="所属厂商"
            style="width: 360px"
            filterable
          >
            <el-option
              v-for="(value, key) in unitlist"
              :key="key"
              :label="value"
              :value="Number(key)"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否显示wifi" prop="is_wifi_show">
          <el-radio-group v-model="form.is_wifi_show" style="width: 360px">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否开启调试模式" prop="is_debug">
          <el-radio-group v-model="form.is_debug" style="width: 360px">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="盒子版本" prop="binded_app_id">
          <el-select
            v-model="form.binded_app_id"
            placeholder="盒子版本"
            style="width: 360px"
            filterable
          >
            <el-option label="最高版本" :value="0"></el-option>
            <el-option
              v-for="(value, key) in applist"
              :key="key"
              :label="value"
              :value="Number(key)"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="信号显示强度" prop="rssi_limit">
          <el-input
            v-model="form.rssi_limit"
            placeholder="不接受信号大于该阈值的传感器的信息"
            style="width: 360px"
          />
        </el-form-item>
        <el-form-item label="是否迎宾版" prop="is_wel_use">
          <el-radio-group v-model="form.is_wel_use" style="width: 360px">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否启用主题" prop="is_enable_theme">
          <el-radio-group v-model="form.is_enable_theme" style="width: 360px">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否强制更新" prop="is_force_update">
          <el-radio-group v-model="form.is_force_update" style="width: 360px">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
          <div>不能更新低于{{ maxboxnum }}以下的版本</div>
        </el-form-item>
        <el-form-item label="盒子名称">
          <el-input
            v-model="form.show_title"
            placeholder="盒子名称"
            style="width: 360px"
          />
        </el-form-item>
        <!-- <el-form-item label='使用类别' prop='use_kind_no'>
          <el-radio-group v-model="form.use_kind_no" style="width: 360px">
            <el-radio label="std">正式发布版</el-radio>
            <el-radio label="beta">测试版</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label='盒子类型' prop='use_type_no'>
          <el-radio-group v-model="form.use_type_no" style="width: 360px">
            <el-radio label="studio">工作室</el-radio>
            <el-radio label="club">俱乐部</el-radio>
          </el-radio-group>
        </el-form-item> -->
      </el-form>
      <div slot="footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleOk">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="主副盒子"
      :visible="areaVisible"
      width="600px"
      :before-close="handleClose"
    >
      <el-form
        @submit.native.prevent
        ref="area-form"
        :model="boxToSet"
        label-width="150px"
        :rules="rules2"
      >
        <el-form-item label="盒子序列号">
          <el-input
            v-model="boxToSet.sn"
            placeholder="盒子序列号"
            style="width: 360px"
            disabled
          />
        </el-form-item>
        <el-form-item label="场馆编码" prop="venue_uuid">
          <el-input
            v-model="boxToSet.venue_uuid"
            placeholder="场馆编码"
            style="width: 360px"
          />
        </el-form-item>
        <el-form-item label="区域编码" prop="venue_uuid">
          <el-input
            v-model="boxToSet.venue_area_uuid"
            placeholder="区域编码"
            style="width: 360px"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="setArea">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { post, get } from "@/utils/http";
import { format } from "@/utils/util";

export default {
  data() {
    return {
      boxlist: [],
      total: 0,
      pageStart: 0,
      pageEnd: 0,
      currentPage: 1,
      pageSize: 200,
      modalVisible: false,
      modalType: "add",
      form: {},
      loading: false,
      unitlist: [],
      applist: "",
      applist2: "",
      filter: {
        is_wifi_show: "all",
        unit_id: "all",
        binded_app_id: "all",
        version_code: "all",
        cdit: "",
      },
      rules: {
        unit_id: [
          {
            required: true,
            message: "请选择厂商",
            trigger: "blur",
          },
        ],
        is_wifi_show: [
          {
            required: true,
            message: "请选择是否显示wifi",
            trigger: "blur",
          },
        ],
        is_debug: [
          {
            required: true,
            message: "请选择是否开启调试模式",
            trigger: "blur",
          },
        ],
        is_enable_theme: [
          {
            required: true,
            message: "请选择是否开启oss调试模式",
            trigger: "blur",
          },
        ],
        binded_app_id: [
          {
            required: true,
            message: "请选择版本",
            trigger: "blur",
          },
        ],
        rssi_limit: [
          {
            required: true,
            message: "请输入信号强度",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (value) {
                if (isNaN(value) || value.length > 5) {
                  callback(new Error("信号强度格式错误"));
                }
                callback();
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        // use_kind_no: [
        //   { required: true, message: '请选择盒子使用类别', trigger: 'blur' }
        // ],
        // use_type_no: [
        //   { required: true, message: '请选择盒子类型', trigger: 'blur' }
        // ],
        is_wel_use: [
          {
            required: true,
            message: "请选择是否迎宾",
            trigger: "blur",
          },
        ],
      },
      expandKey: [],
      boxToSet: {},
      areaVisible: false,
      rules2: {
        venue_uuid: [
          {
            required: true,
            message: "场馆编码不能为空",
            trigger: "blur",
          },
        ],
        venue_area_uuid: [
          {
            required: true,
            message: "区域编码不能为空",
            trigger: "blur",
          },
        ],
      },
      boxListCount: 0,

      maxboxnum: "",
      sessions_cloud: [],
      expandKey: [],
    };
  },
  computed: {
    ...mapState([
      "user_id",
      "unit_id",
      "user_is_pta",
      "user_is_admin",
      "box_use_kind",
      "box_use_type",
    ]),
  },
  mounted() {
    this.getBoxlist();
    this.getApps();
    this.getUnitlist();
    this.getBoxListNum();
  },
  methods: {
    //当前在线盒子数
    async getBoxListNum() {
      const res = await post("/box/index/count_online_box");
      console.log(res);
      this.boxListCount = res.data.count;
    },
    // 获取盒子列表
    async getBoxlist() {
      this.loading = true;
      this.expandKey = [];
      const { is_wifi_show, unit_id, binded_app_id, cdit, version_code } =
        this.filter;
      const data = {
        page_ix: this.currentPage,
        page_size: this.pageSize,
      };
      if (is_wifi_show != "all") {
        data.is_wifi_show = is_wifi_show;
      }
      if (unit_id != "all") {
        data.unit_id = unit_id;
      }
      if (binded_app_id != "all") {
        data.binded_app_id = binded_app_id;
      }
      if (version_code != "all") {
        data.version_code = version_code;
      }
      if (cdit) {
        data.cdit = cdit;
      }
      try {
        const res = await post("/box/Index/queryBox", data);
        this.loading = false;
        if (res && res.rst == 0) {
          this.boxlist = res.data.data;
          this.total = res.data.total;
          this.pageStart = (res.data.current_page - 1) * this.pageSize;
          this.pageEnd = this.pageStart + this.pageSize;
        }
      } catch (err) {
        this.loading = false;
      }
    },
    // 获取厂商列表
    async getUnitlist() {
      try {
        const res = await get("/index/Unit/getUnits");
        if (res && res.rst == 0) {
          let temp = {};
          res.data.forEach((d) => {
            temp[d.id] = d.name;
          });
          this.unitlist = temp;
        }
      } catch (err) {}
    },
    // 获取版本列表
    async getApps() {
      try {
        const res = await get("/index/Box/getApps");
        if (res && res.rst == 0) {
          let temp = {};
          let temp2 = {};
          res.data.forEach((d) => {
            temp[d.id] = d.version_name;
            temp2[d.version_code] = d.version_name;
          });
          this.applist = temp;
          this.applist2 = temp2;

          //取最新版本的盒子
          var listArr = [];
          for (let key in res.data) {
            listArr.push(res.data[key].version_name);
          }
          listArr.sort((num1, num2) => {
            return num1 - num2 < 0;
          });
          this.maxboxnum = listArr[0];
        }
      } catch (err) {}
    },
    handleSet(box) {
      console.log(box, this.unitlist, this.unitlist[box["unit_id"]]);
      if (!this.unitlist[box["unit_id"]]) {
        box["unit_id"] = "";
      }
      this.form = {
        ...box,
      };
      this.modalVisible = true;
      this.modalType = "set";
      console.log("111", this.form);
    },
    setArea(box) {
      this.$refs["area-form"].validate(async (valid) => {
        if (valid) {
          try {
            const res = await post("/box/Index/setBox", {
              id: this.boxToSet.id,
              venue_uuid: this.boxToSet.venue_uuid,
              venue_area_uuid: this.boxToSet.venue_area_uuid,
            });
            if (res && res.rst == 0) {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.handleClose();
              this.getBoxlist();
              return;
            }
            this.$message.error(res.msg);
          } catch (err) {
            this.$message.error("修改失败");
          }
        }
      });
    },
    handleRemove(box) {
      this.$confirm("确定要删除盒子 " + box.sn + " 吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        try {
          const res = await post("/box/Index/removeBox", {
            id: box.id,
          });
          if (res && res.rst == 0) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getBoxlist();
          }
        } catch (err) {
          this.$message({
            type: "info",
            message: "删除失败请重试",
          });
        }
      });
    },
    handleOk() {
      const {
        id,
        unit_id,
        is_wifi_show,
        binded_app_id,
        rssi_limit,
        use_kind_no,
        use_type_no,
        is_wel_use,
        show_title,
        is_debug,
        is_enable_theme,
        is_force_update,
      } = this.form;
      this.$refs["box-form"].validate(async (valid) => {
        if (valid) {
          try {
            const res = await post("/box/Index/setBox", {
              id,
              unit_id,
              is_wifi_show,
              binded_app_id,
              rssi_limit,
              use_kind_no,
              use_type_no,
              is_wel_use,
              show_title,
              is_debug,
              is_enable_theme,
              is_force_update,
            });
            if (res && res.rst == 0) {
              this.$message({
                message: "修改成功",
                type: "success",
              });
              this.handleClose();
              this.getBoxlist();
              return;
            }
            this.$message.error(res.msg);
          } catch (err) {
            this.$message.error("修改失败");
          }
        }
      });
    },

    // MQ盒子
    mqBox(box) {
      this.$confirm("确定要MQ盒子" + box.sn + "吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        try {
          const res = await post("/run/Timed/checkMqOnline", {
            box_id: box.id,
          });
          if (res && res.rst == 0) {
            this.$message({
              message: "指令发送成功",
              type: "success",
            });
            this.getBoxlist();
          }
        } catch (err) {
          this.$message({
            type: "info",
            message: "指令发送失败",
          });
        }
      });
    },

    // 重启盒子
    restartBox(box) {
      let text =
        box == "all"
          ? "确定要重启所有盒子吗?"
          : "确定要重启盒子 " + box.sn + " 吗?";
      const handle = async () => {
        try {
          const res = await post("/run/Timed/repowerCall", {
            box_id: box == "all" ? "all" : box.id,
          });
          if (res && res.rst == 0) {
            this.$message({
              message: "指令发送成功",
              type: "success",
            });
            this.getBoxlist();
          }
        } catch (err) {
          this.$message({
            type: "info",
            message: "指令发送失败",
          });
        }
      };
      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (box == "all") {
          text = "真的确定要重启所有盒子吗？";
          this.$confirm(text, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            text = "真的真的确定要重启所有盒子吗？";
            this.$confirm(text, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }).then(() => {
              handle();
            });
          });
          return;
        }
        handle();
      });
    },

    // 删除静态文件
    clearStaticFile(box) {
      let text = "确定要删除盒子 " + box.sn + " 的静态文件吗?";
      const handle = async () => {
        try {
          const res = await post("/run/Timed/clearStaticFile", {
            box_id: box.id,
          });
          if (res && res.rst == 0) {
            this.$message({
              message: "指令发送成功",
              type: "success",
            });
            this.getBoxlist();
          }
        } catch (err) {
          this.$message({
            type: "info",
            message: "指令发送失败",
          });
        }
      };
      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        handle();
      });
    },

    onExpandChange(row, expandedRows) {
      if (expandedRows.length > 1) {
        expandedRows.shift();
      }
    },

    showLog(box) {
      this.$router.push("boxlognew/" + box.sn);
    },
    handleClose() {
      this.modalVisible = false;
      this.areaVisible = false;
      setTimeout(() => {
        this.modalType = "";
        this.resetForm();
        this.form = {};
        this.boxToSet = {};
      }, 200);
    },
    onPageChange(page) {
      this.currentPage = page;
      this.getBoxlist();
    },
    resetForm() {
      if (this.$refs["box-form"]) this.$refs["box-form"].resetFields();
      if (this.$refs["area-form"]) this.$refs["area-form"].resetFields();
    },
    format(date, fmt) {
      format(date, fmt);
    },
    indexMethod(index) {
      return index + this.pageStart + 1;
    },
  },
  name: "boxlist",
};
</script>
<style lang='less'>
.boxlist {
  .el-select,
  .el-input {
    width: 100%;
  }

  .expanded {
    color: black;
    background-color: #f5f7fa;
  }
}
</style>
